import { memo } from 'react';

import DownloadIconSVG from '@/assets/download-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDownloadIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DownloadIconSVG} {...props} />;

export const DownloadIcon = memo(IDownloadIcon) as typeof IDownloadIcon;
